import { IconFont } from '@/components/IconFont'
import { getOrganizationMembers } from '@/services/member/member'
import { useRequest } from 'ahooks'
import { Button } from 'antd'
import { memo, useContext, useMemo } from 'react'
import { OrganizationContext } from '../..'
import { MemberTable } from '../MemberTable/MemberTable'
import InvitationMember from '../InvitationMember'


export default memo(function OrganizationOutsideMembers() {
  const orgData = useContext(OrganizationContext).orgData!
  const { data, refresh, loading } = useRequest(() =>
    getOrganizationMembers(orgData.id, '')
  )

  const members = useMemo(() => {
    return (data || []).filter(item => item.groups.length === 0)
  }, [data])

  return <MemberTable
    loading={loading}
    reload={refresh}
    data={members || []} org={orgData} actions={
    <InvitationMember
      trigger={
        <Button type={'primary'} icon={<IconFont type='icon-add' />}>
          Invite External Member
        </Button>
      }
    />
  } />
})
